import React, {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import Get from './components/Get';
import BottomTabs from './BottomTabs';
import {FaPlus, FaWallet} from 'react-icons/fa';
import {FaPaypal, FaCreditCard, FaGooglePay} from 'react-icons/fa';
import {SiPaytm, SiPhonepe} from 'react-icons/si'; // more icons from simple-icons

const WalletOption = () => {
  const [balance, setBalance] = useState(0);
  const [methods, setMethods] = useState([]);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const methodIcons = {
    paypal: <FaPaypal />,
    creditcard: <FaCreditCard />,
    paytm: <SiPaytm />,
    phonepe: <SiPhonepe />,
    gpay: <FaGooglePay />,
    wallet: <FaWallet />,
  };

  useEffect(() => {
    getMethods();
    getStatement();
  }, []);

  const getMethods = () => {
    Get.Method()
      .then(res => {
        setMethods(Array.isArray(res?.data) ? res.data.filter(Boolean) : []);
      })
      .catch(() => setMethods([]));
  };

  const getStatement = () => {
    setLoading(true);
    Get.Wallet()
      .then(res => {
        setBalance(res?.wallet?.balance ?? 0);
        const transactions = Array.isArray(res?.transection)
          ? res.transection.flatMap(group =>
              Array.isArray(group?.data)
                ? group.data.filter(item => item && typeof item === 'object')
                : [],
            )
          : [];
        setData(transactions);
      })
      .catch(error => {
        console.error('Unable to load wallet transactions:', error);
        setBalance(0);
        setData([]);
      })
      .finally(() => setLoading(false));
  };

  const navigateTo = (path, state) => {
    navigate(path, {state});
  };

  return (
    <>
      <div style={styles.container}>
        <div style={styles.headerContainer}>
          <h2 style={styles.headerTitle}>My Wallet</h2>
        </div>

        <div style={styles.balanceCard}>
          <div style={styles.balanceHeader}>
            <div style={styles.walletIconContainer}>
              <span role="img" aria-label="wallet">
                <FaWallet />
              </span>
            </div>
            <div>
              <p style={styles.balanceLabel}>Available Balance</p>
              <h3 style={styles.balanceAmount}>₹ {balance}</h3>
            </div>
          </div>
          <button
            style={styles.addMoneyBtn}
            onClick={() => navigateTo('/addmoney')}>
            <FaPlus /> Add Money
          </button>
        </div>

        <div style={styles.contentContainer}>
          <h3 style={styles.sectionTitle}>Withdrawal Methods</h3>
          <div style={styles.methodsScroll}>
            {methods.map((method, i) => (
              <div
                key={i}
                style={styles.methodCard}
                onClick={() =>
                  navigateTo('/withdraw', {
                    method_id: method.id,
                    title: method.name,
                  })
                }>
                <div style={styles.methodIcon}>
                  {methodIcons[
                    method.name.toLowerCase().replace(/\s/g, '')
                  ] || <FaWallet />}{' '}
                  {/* fallback */}
                </div>

                <p style={styles.methodName}>{method.name}</p>
              </div>
            ))}
          </div>

          <h3 style={styles.sectionTitle}>Transaction History</h3>
          <div style={styles.transactionsList}>
            {loading ? (
              <p>Loading...</p>
            ) : data.length ? (
              data.map((item, index) => (
                <div key={index} style={styles.transactionCard}>
                  <div style={styles.transactionIcon}>
                    <span
                      role="img"
                      aria-label={item.transection || 'transaction'}>
                      {item.transection === 'debit' ? '⬆️' : '⬇️'}
                    </span>
                  </div>
                  <div style={styles.transactionDetails}>
                    <p style={styles.transactionMessage}>{item.message}</p>
                    <p style={styles.transactionDate}>{item.date}</p>
                  </div>
                  <div style={styles.transactionAmount}>
                    <p
                      style={{
                        ...styles.amountText,
                        color:
                          item.transection === 'debit' ? '#EDA01E' : '#21CB84',
                      }}>
                      {item.transection === 'debit' ? '-' : '+'}₹{item.amount}
                    </p>
                  </div>
                </div>
              ))
            ) : (
              <p>No transactions yet</p>
            )}
          </div>
        </div>
      </div>
      <BottomTabs />
    </>
  );
};

export default WalletOption;

const styles = {
  container: {
    padding: '0px',
    fontFamily: 'Arial, sans-serif',
    backgroundColor: '#f8fafb',
  },
  headerContainer: {
    backgroundColor: '#00318bff',
    padding: '10px',
    borderBottomLeftRadius: '30px',
    borderBottomRightRadius: '30px',
    textAlign: 'center',
  },
  headerTitle: {
    color: 'white',
  },
  balanceCard: {
    backgroundColor: 'rgb(233 233 233)',
    borderRadius: '10px',
    padding: '20px',
    margin: '20px 15px',
  },
  balanceHeader: {
    display: 'flex',
    alignItems: 'center',
  },
  walletIconContainer: {
    width: '50px',
    height: '50px',
    backgroundColor: '#f3de11',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: '10px',
  },
  balanceLabel: {
    fontSize: '14px',
    color: '#6b7280',
    marginBottom: '5px',
    marginTop: '0px',
  },
  balanceAmount: {
    fontSize: '24px',
    color: '#1057d7',
    margin: '0px',
  },
  addMoneyBtn: {
    marginTop: '30px',
    padding: '12px 20px',
    backgroundColor: '#21cb84',
    color: 'white',
    border: 'none',
    borderRadius: '10px',
    cursor: 'pointer',
    width: '100%',
  },
  contentContainer: {
    marginTop: '20px',
    marginBottom: '50px',
  },
  sectionTitle: {
    fontSize: '18px',
    marginBottom: '10px',
  },
  methodsScroll: {
    display: 'flex',
    gap: '10px',
    overflowX: 'auto',
  },
  methodCard: {
    width: '100px',
    padding: '10px',
    backgroundColor: '#fff',
    borderRadius: '10px',
    textAlign: 'center',
    cursor: 'pointer',
  },
  methodIcon: {
    marginBottom: '5px',
  },
  methodImage: {
    width: '60px',
    height: '60px',
  },
  methodName: {
    fontSize: '14px',
  },
  transactionsList: {
    marginTop: '20px',
  },
  transactionCard: {
    backgroundColor: '#fff',
    padding: '10px',
    borderRadius: '10px',
    display: 'flex',
    alignItems: 'center',
    marginBottom: '10px',
  },
  transactionIcon: {
    width: '40px',
    height: '40px',
    backgroundColor: '#09b7ae',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: '10px',
  },
  transactionDetails: {
    flex: 1,
  },
  transactionMessage: {
    fontSize: '14px',
    marginBottom: '5px',
  },
  transactionDate: {
    fontSize: '12px',
    color: '#6b7280',
  },
  transactionAmount: {
    textAlign: 'right',
  },
  amountText: {
    fontSize: '16px',
    fontWeight: 'bold',
  },
};
